import React from 'react';
import SafeHtml from '../../components/SafeHtml';

const ImageDrawoverRenderer = ({ block }) => {
  const content = block.content || '';

  // Fallback when block data is missing or empty
  if (!content) {
    return (
      <div className="image-drawover-block my-4 p-6 bg-gray-50 border-2 border-dashed border-gray-300 rounded-lg text-center">
        <p className="text-gray-500 text-sm font-medium">Image Draw-Over</p>
        <p className="text-gray-400 text-xs mt-1">No draw-over content saved. Open the shape builder to create one.</p>
      </div>
    );
  }

  // The content is either a data URL (PNG) or an SVG string
  const isPng = content.startsWith('data:image/');

  return (
    <div className="image-drawover-block my-4">
      {isPng ? (
        <img
          src={content}
          alt="Image draw-over"
          className="max-w-full h-auto rounded-lg border border-gray-200 shadow-sm"
          style={{ display: 'block', margin: '0 auto' }}
        />
      ) : (
        // fabric's toSVG() output. The sanitizer allows the drawing
        // primitives and the base64 backdrop on <image xlink:href>, and
        // forbids the script vectors that can hide inside SVG.
        <SafeHtml
          className="drawover-svg-container"
          html={content}
          style={{ maxWidth: '100%', overflow: 'hidden' }}
        />
      )}
      {block.backgroundImage && (
        <p className="text-xs text-gray-400 mt-1 text-center italic">
          Image draw-over annotation
        </p>
      )}
    </div>
  );
};

export default ImageDrawoverRenderer;
